import type { SceneTemplate, SceneTemplateVariation } from "./lomdaTypes";

const baseConfig: Omit<SceneTemplate, "name"> = {
    aspectRatio: "16:9",
    branding: { background: "background", foreground: undefined },
    scene: {
        scale: 100,
        rounded: false,
        location: { x: 0, y: 0 },
    },
};

export const SCENE_TEMPLATES: Record<SceneTemplateVariation, SceneTemplate> = {
    A: { ...baseConfig, name: "lomda.scene-template.A" },
    B: {
        ...baseConfig,
        name: "lomda.scene-template.B",
        mediaSlot: true,
    },
    C: {
        ...baseConfig,
        name: "lomda.scene-template.C",
        mediaSlot: true,
    },
    D: {
        ...baseConfig,
        name: "lomda.scene-template.D",
        mediaSlot: true,
    },
    E: { ...baseConfig, name: "lomda.scene-template.E" },
};

export function templateHasMediaSlot(
    template: SceneTemplateVariation
): boolean {
    return SCENE_TEMPLATES[template]?.mediaSlot === true;
}
